export default {
    introduction: {
        title: 'Trendone Demo Radar',
        text1: 'Get to know the Trend Radar: Identify, assess and monitor your relevant trends. Understand the impact of trends on your company and your industry. The Trend Radar offers you a decision-making and orientation tool in your work with trends and innovations and serves for transparent communication throughout the company.',
        text2: 'For inspiration, our team has created a demo radar for you. Feel free to contact us if you would like to create your own trend radars for your team. We will be happy to activate the function for you for a test phase.'
    }
}
